import { postLastActivityEntityGQLFields, } from './post-last-activity-entity.fields.js';
const BASIC_POST_LAST_ACTIVITY_DETAIL_FIELDS = {};
const ALL_POST_LAST_ACTIVITY_DETAIL_FIELDS = {
    entity: 'basic',
};
const DEFAULT_POST_LAST_ACTIVITY_DETAIL_FIELDS = {
    entity: {
        onPost: 'basic',
        onPostReactionParticipant: {
            participant: 'basic',
            reaction: {
                fields: 'all',
                variables: {
                    limit: 25,
                },
            },
        },
    },
};
export const postLastActivityDetailGQLFields = (fields) => {
    if (fields === 'basic')
        fields = BASIC_POST_LAST_ACTIVITY_DETAIL_FIELDS;
    if (fields === 'all')
        fields = ALL_POST_LAST_ACTIVITY_DETAIL_FIELDS;
    if (fields === 'default')
        fields = DEFAULT_POST_LAST_ACTIVITY_DETAIL_FIELDS;
    return `
    entityId
    entityType
    ${fields.entity
        ? `
      entity {
        ${postLastActivityEntityGQLFields(fields.entity)}
      }
    `
        : ``}
  `;
};
//# sourceMappingURL=post-last-activity-detail.fields.js.map